<script setup>
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n({ useScope: "global" });
</script>
<script>
export default {
    name: "PageContainerFooter",
};
</script>

<template>
    <div class="dp-flex justify-content__center footer">
        <a
            :href="`https://www.dutypay.eu/${locale}/privacy-policy`"
            tabindex="0"
            target="_blank"
            >{{ t("sso.components.PageContainerFooter.privacyPolicy.linkLabel") }}</a
        >
        <a
            :href="`https://www.dutypay.eu/${locale}/terms-of-use`"
            tabindex="0"
            target="_blank"
            >{{ t("sso.components.PageContainerFooter.termsOfUse.linkLabel") }}</a
        >
    </div>
</template>

<i18n>
{
  "ar-AE": {
    "termsOfUse": {
      "linkLabel": "شروط الاستخدام"
    },
    "privacyPolicy": {
      "linkLabel": "إعلان حماية البيانات"
    }
  },
  "ar-DZ": {
    "termsOfUse": {
      "linkLabel": "شروط الاستخدام"
    },
    "privacyPolicy": {
      "linkLabel": "إعلان حماية البيانات"
    }
  },
  "ar-EG": {
    "termsOfUse": {
      "linkLabel": "شروط الاستخدام"
    },
    "privacyPolicy": {
      "linkLabel": "إعلان حماية البيانات"
    }
  },
  "ar-LB": {
    "termsOfUse": {
      "linkLabel": "شروط الاستخدام"
    },
    "privacyPolicy": {
      "linkLabel": "إعلان حماية البيانات"
    }
  },
  "ar-MA": {
    "termsOfUse": {
      "linkLabel": "شروط الاستخدام"
    },
    "privacyPolicy": {
      "linkLabel": "إعلان حماية البيانات"
    }
  },
  "ar-SA": {
    "termsOfUse": {
      "linkLabel": "تعليمات الاستخدام"
    },
    "privacyPolicy": {
      "linkLabel": "إعلان حماية البيانات"
    }
  },
  "ar-SY": {
    "termsOfUse": {
      "linkLabel": "شروط الاستخدام"
    },
    "privacyPolicy": {
      "linkLabel": "إعلان حماية البيانات"
    }
  },
  "ar-TN": {
    "termsOfUse": {
      "linkLabel": "شروط الاستخدام"
    },
    "privacyPolicy": {
      "linkLabel": "إعلان حماية البيانات"
    }
  },
  "bg-BG": {
    "termsOfUse": {
      "linkLabel": "Условия за ползване"
    },
    "privacyPolicy": {
      "linkLabel": "Декларация за защита на данните"
    }
  },
  "bs-BA": {
    "termsOfUse": {
      "linkLabel": "Pravila korištenja"
    },
    "privacyPolicy": {
      "linkLabel": "Izjava o zaštiti podataka"
    }
  },
  "cs-CZ": {
    "termsOfUse": {
      "linkLabel": "Podmínky použití"
    },
    "privacyPolicy": {
      "linkLabel": "Prohlášení o ochraně údajů"
    }
  },
  "da-DK": {
    "termsOfUse": {
      "linkLabel": "Betingelser for brug"
    },
    "privacyPolicy": {
      "linkLabel": "Databeskyttelseserklæring"
    }
  },
  "de-DE": {
    "termsOfUse": {
      "linkLabel": "Nutzungsbedingungen"
    },
    "privacyPolicy": {
      "linkLabel": "Datenschutzerklärung"
    }
  },
  "de-AT": {
    "termsOfUse": {
      "linkLabel": "Nutzungsbedingungen"
    },
    "privacyPolicy": {
      "linkLabel": "Datenschutzerklärung"
    }
  },
  "de-CH": {
    "termsOfUse": {
      "linkLabel": "Nutzungsbedingungen"
    },
    "privacyPolicy": {
      "linkLabel": "Datenschutzerklärung"
    }
  },
  "de-LU": {
    "termsOfUse": {
      "linkLabel": "Nutzungsbedingungen"
    },
    "privacyPolicy": {
      "linkLabel": "Datenschutzerklärung"
    }
  },
  "el-GR": {
    "termsOfUse": {
      "linkLabel": "Οροι χρήσης"
    },
    "privacyPolicy": {
      "linkLabel": "Δήλωση προστασίας δεδομένων"
    }
  },
  "el-CY": {
    "termsOfUse": {
      "linkLabel": "Οροι χρήσης"
    },
    "privacyPolicy": {
      "linkLabel": "Δήλωση προστασίας δεδομένων"
    }
  },
  "en-GB": {
    "termsOfUse": {
      "linkLabel": "Terms of Use"
    },
    "privacyPolicy": {
      "linkLabel": "Data Protection Declaration"
    }
  },
  "en-IE": {
    "termsOfUse": {
      "linkLabel": "Terms of Use"
    },
    "privacyPolicy": {
      "linkLabel": "Data Protection Declaration"
    }
  },
  "en-US": {
    "termsOfUse": {
      "linkLabel": "Terms of Use"
    },
    "privacyPolicy": {
      "linkLabel": "Data Protection Declaration"
    }
  },
  "es-ES": {
    "termsOfUse": {
      "linkLabel": "Términos de Uso"
    },
    "privacyPolicy": {
      "linkLabel": "Declaración de protección de datos"
    }
  },
  "et-EE": {
    "termsOfUse": {
      "linkLabel": "Kasutustingimused"
    },
    "privacyPolicy": {
      "linkLabel": "Andmekaitsedeklaratsioon"
    }
  },
  "fi-FI": {
    "termsOfUse": {
      "linkLabel": "Käyttöehdot"
    },
    "privacyPolicy": {
      "linkLabel": "Tietosuojailmoitus"
    }
  },
  "fr-BE": {
    "termsOfUse": {
      "linkLabel": "Conditions d’utilisation"
    },
    "privacyPolicy": {
      "linkLabel": "Déclaration de protection des données"
    }
  },
  "fr-CH": {
    "termsOfUse": {
      "linkLabel": "Conditions d’utilisation"
    },
    "privacyPolicy": {
      "linkLabel": "Déclaration de protection des données"
    }
  },
  "fr-FR": {
    "termsOfUse": {
      "linkLabel": "Conditions d’utilisation"
    },
    "privacyPolicy": {
      "linkLabel": "Déclaration de protection des données"
    }
  },
  "fr-LU": {
    "termsOfUse": {
      "linkLabel": "Conditions d’utilisation"
    },
    "privacyPolicy": {
      "linkLabel": "Déclaration de protection des données"
    }
  },
  "ga-IE": {
    "termsOfUse": {
      "linkLabel": "Téarmaí Úsáide"
    },
    "privacyPolicy": {
      "linkLabel": "Dearbhú cosanta sonraí"
    }
  },
  "he-IL": {
    "termsOfUse": {
      "linkLabel": "תנאי שימוש"
    },
    "privacyPolicy": {
      "linkLabel": "הצהרת הגנת נתונים"
    }
  },
  "hi-IN": {
    "termsOfUse": {
      "linkLabel": "उपयोग की शर्तें"
    },
    "privacyPolicy": {
      "linkLabel": "डाटा सुरक्षा घोषणा"
    }
  },
  "hr-HR": {
    "termsOfUse": {
      "linkLabel": "Uvjeti korištenja"
    },
    "privacyPolicy": {
      "linkLabel": "Izjava o zaštiti podataka"
    }
  },
  "hu-HU": {
    "termsOfUse": {
      "linkLabel": "Használati feltételek"
    },
    "privacyPolicy": {
      "linkLabel": "Adatvédelmi nyilatkozat"
    }
  },
  "it-CH": {
    "termsOfUse": {
      "linkLabel": "Termini di utilizzo"
    },
    "privacyPolicy": {
      "linkLabel": "Dichiarazione sulla protezione dei dati"
    }
  },
  "it-IT": {
    "termsOfUse": {
      "linkLabel": "Condizioni d'uso"
    },
    "privacyPolicy": {
      "linkLabel": "Dichiarazione sulla protezione dei dati"
    }
  },
  "ja-JP": {
    "termsOfUse": {
      "linkLabel": "利用規約"
    },
    "privacyPolicy": {
      "linkLabel": "データ保護宣言"
    }
  },
  "ko-KR": {
    "termsOfUse": {
      "linkLabel": "이용 약관"
    },
    "privacyPolicy": {
      "linkLabel": "데이터 보호 선언"
    }
  },
  "lt-LT": {
    "termsOfUse": {
      "linkLabel": "Naudojimo sąlygos"
    },
    "privacyPolicy": {
      "linkLabel": "Duomenų apsaugos deklaracija"
    }
  },
  "lv-LV": {
    "termsOfUse": {
      "linkLabel": "Lietošanas noteikumi"
    },
    "privacyPolicy": {
      "linkLabel": "Datu aizsardzības deklarācija"
    }
  },
  "mt-MT": {
    "termsOfUse": {
      "linkLabel": "Termini ta'Użu"
    },
    "privacyPolicy": {
      "linkLabel": "Dikjarazzjoni ta' Protezzjoni tad-Data"
    }
  },
  "nb-NO": {
    "termsOfUse": {
      "linkLabel": "Bruksvilkår"
    },
    "privacyPolicy": {
      "linkLabel": "Deklarasjon om databeskyttelse"
    }
  },
  "nl-BE": {
    "termsOfUse": {
      "linkLabel": "Gebruiksvoorwaarden"
    },
    "privacyPolicy": {
      "linkLabel": "Verklaring gegevensbescherming"
    }
  },
  "nl-NL": {
    "termsOfUse": {
      "linkLabel": "Gebruiksvoorwaarden"
    },
    "privacyPolicy": {
      "linkLabel": "Verklaring gegevensbescherming"
    }
  },
  "pl-PL": {
    "termsOfUse": {
      "linkLabel": "Warunki korzystania"
    },
    "privacyPolicy": {
      "linkLabel": "Oświadczenie o ochronie danych"
    }
  },
  "pt-PT": {
    "termsOfUse": {
      "linkLabel": "Termos de uso"
    },
    "privacyPolicy": {
      "linkLabel": "Declaração de proteção de dados"
    }
  },
  "ro-RO": {
    "termsOfUse": {
      "linkLabel": "Termeni de utilizare"
    },
    "privacyPolicy": {
      "linkLabel": "Declarație privind protecția datelor"
    }
  },
  "ru-RU": {
    "termsOfUse": {
      "linkLabel": "Условия эксплуатации"
    },
    "privacyPolicy": {
      "linkLabel": "Заявление о защите данных"
    }
  },
  "sk-SK": {
    "termsOfUse": {
      "linkLabel": "Podmienky používania"
    },
    "privacyPolicy": {
      "linkLabel": "Vyhlásenie o ochrane údajov"
    }
  },
  "sl-SI": {
    "termsOfUse": {
      "linkLabel": "Pogoji uporabe"
    },
    "privacyPolicy": {
      "linkLabel": "Izjava o varstvu podatkov"
    }
  },
  "sv-SE": {
    "termsOfUse": {
      "linkLabel": "Villkor"
    },
    "privacyPolicy": {
      "linkLabel": "Dataskyddsdeklaration"
    }
  },
  "th-TH": {
    "termsOfUse": {
      "linkLabel": "เงื่อนไขการใช้งาน"
    },
    "privacyPolicy": {
      "linkLabel": "ประกาศการป้องกันข้อมูล"
    }
  },
  "tr-CY": {
    "termsOfUse": {
      "linkLabel": "Kullanım Şartları"
    },
    "privacyPolicy": {
      "linkLabel": "Veri koruma beyanı"
    }
  },
  "tr-TR": {
    "termsOfUse": {
      "linkLabel": "Kullanım Şartları"
    },
    "privacyPolicy": {
      "linkLabel": "Veri koruma beyanı"
    }
  },
  "uk-UA": {
    "termsOfUse": {
      "linkLabel": "Умови користування"
    },
    "privacyPolicy": {
      "linkLabel": "Декларація захисту даних"
    }
  },
  "vi-VN": {
    "termsOfUse": {
      "linkLabel": "Điều khoản sử dụng"
    },
    "privacyPolicy": {
      "linkLabel": "Tuyên bố bảo vệ dữ liệu"
    }
  },
  "zh-CN": {
    "termsOfUse": {
      "linkLabel": "使用条款"
    },
    "privacyPolicy": {
      "linkLabel": "数据保护声明"
    }
  }
}
</i18n>

<style scoped lang="scss">
.footer {
    -webkit-text-size-adjust: 100%;
    margin: 1.5rem 1em;
    text-align: center;
    gap: 1em;
    flex-wrap: wrap;
    border-top: 1px solid var(--application-color--lighter);
    padding-top: 20px;
    margin-top: 40px;
    a {
        &:hover {
            text-decoration: underline;
        }
        @media screen and (max-width: 768px) {
            font-size: 12px;
            display: block;
            margin: 0;
        }
    }
}
</style>
